import React from "react";
import { Link } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { RiFolderInfoFill } from "react-icons/ri";
import { motion } from "framer-motion";
import Lottie from "react-lottie";
import coding from "../../../assets/coding.json";
import "../../../pages/shared/Shared.css";
import { SecondaryBtn } from "../../../components";

const Banner = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: coding,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="parent min-h-[100vh] flex flex-col-reverse lg:flex-row items-center justify-between">
      <motion.div
        initial={{ x: "-100vw" }}
        animate={{ x: 0 }}
        transition={{ duration: 3 }}
      >
        <h2 className="text-neutral text-xl font-medium translate-y-[-90%] sm:translate-y-[-0%]">
          Hello, I'm
        </h2>
        <h1 className="text-4xl font-semibold translate-y-[-50%] sm:translate-y-[-0%] sm:text-sm sm:mt-2">
          Shyam Sundar Vashishtha
        </h1>
        <p className="text-neutral max-w-xl mb-6 font-medium translate-y-[-20%] sm:translate-y-[-0%]">
          Skilled in multiple programming languages and web development
          technologies, I have a passion for creating innovative solutions to
          complex problems. With experience in C/C++, Python, Java, HTML5, CSS3,
          JavaScript, Bootstrap, ReactJS, NodeJS, MongoDB, ExpressJS, SQL and
          familiarity with Amazon Web Services (AWS) platform for cloud-based
          solutions. I am able to tackle challenges head-on and deliver
          high-quality results. With a strong track record of success and a
          commitment to excellence, I am always striving to push the boundaries
          of what is possible. My ability to think outside the box and
          collaborate effectively with others makes me a valuable asset to any
          team.
        </p>

        <div className="flex items-center translate-y-[-60%] sm:translate-y-[-0%]">
          <a
            href="https://drive.google.com/file/d/1mxA1mfXVC_8-0eFs03LmRFlR6J2MChmi/view?usp=drivesdk"
            target="blank"
          >
            <button className="primary-button">
              <span>My Resume</span>
              <span>
                <FaDownload />
              </span>
            </button>
          </a>
          <Link to="/about" className="ml-4">
            <SecondaryBtn>
              <span>About Me</span>
              <span>
                <RiFolderInfoFill />
              </span>
            </SecondaryBtn>
          </Link>
        </div>
      </motion.div>
      <motion.div
        className="w-full md:w-1/2"
        initial={{ x: "100vw" }}
        animate={{ x: 0 }}
        transition={{ duration: 1 }}
      >
        <Lottie options={defaultOptions} height="90%" width="90%" />
      </motion.div>
    </div>
  );
};

export default Banner;
